<template>
    <div>
        <trading-vue
            ref="OneDealChart"
            type="candles"
            :toolbar="true"
            color-back="#ffffff"
            color-grid="#eee"
            color-text="#333"
            :timezone="0"
            :titleTxt="'Deal '+deal.token"
            :data="chartData"
            :chart-config="{DEFAULT_LEN: 400, ZOOM_MODE: 'tv'}"
        ></trading-vue>
    </div>
</template>
<script>
import TradingVue from 'trading-vue-js'
import Overlays from 'tvjs-overlays'
import { utcToZonedTime, format }  from 'date-fns-tz'
import { add, sub } from 'date-fns'
import helperMethods from "@/helpers";
export default {
    props:{
        candles: Array,
        deal: Object
    },
    components:{
        TradingVue
    },
    data(){
        return {
            // overlays: [Overlays['TradesPlus']]
        }
    },
    mounted(){
        // this.$refs.OneDealChart.resetChart()
        // let timeStart = format(Date.parse(this.deal.started_at), "T");
        // let timeEnd = format(Date.parse(this.deal.completed_at), "T");
        // this.$nextTick(() =>
        //     this.$refs.OneDealChart.setRange(timeStart, timeEnd)
        // )
    },
    computed:{
        chartData(){
            let timeStart = format(sub(Date.parse(this.deal.started_at), { minutes: 10 }), "T");
            let timeEnd;
            if(this.deal.completed_at) timeEnd = format(add(Date.parse(this.deal.completed_at), { minutes: 10 }), "T");
            else timeEnd = format(Date().now(), "T");
            let dealCandles = this.candles.filter((candle)=> {
                return candle.open_time >= timeStart && candle.open_time <= timeEnd;
                //return true;
            });
            //console.log(dealCandles);
            return {
                ohlcv: this.ohlcvFromCandles(dealCandles),
                onchart:[
                    {
                        name: "Deals",
                        type: "Trades",
                        data: [
                            [this.timestamp(this.deal.started_at), 1, this.deal.rate_started],
                            [this.timestamp(this.deal.completed_at), 0, this.deal.rate_completed]
                        ],
                    },
                ]
            };
        },

    },
    methods:{
        ...helperMethods,
    }
}
</script>
